import { useEffect, useRef, useState } from 'react'
import ShadowContainer from '@/ui/components/shared/ShadowContainer'
import Search from '@/ui/icons/Search'
import Spinner from '@/ui/components/shared/Spinner'

const INPUT_DEBOUNCE_DELAY = 500 // ms

const SearchBar = ({ updateSearchValue }) => {
    const debounceCallback = useRef(null)

    const [rawSearchValue, setRawSearchValue] = useState({
        value: '',
        loading: false
    })

    function debounceCall(value) {
        if (debounceCallback.current !== null) clearTimeout(debounceCallback.current)
        debounceCallback.current = setTimeout(() => {
            updateSearchValue(value)
            setRawSearchValue({
                value: value,
                loading: false
            })
        }, INPUT_DEBOUNCE_DELAY)
    }

    useEffect(() => {
        if (rawSearchValue.value) {
            debounceCall(rawSearchValue.value)
            return
        }
        clearTimeout(debounceCallback.current)
        updateSearchValue(rawSearchValue.value)
    }, [debounceCall, rawSearchValue, updateSearchValue])

    return (
        <ShadowContainer customStyle={'flex flex-row md:-mb-10'} hoverAble={false}>
            <div className={'pl-4 pr-2 '}>
                <Search />
            </div>

            <input
                type={'text'}
                disabled={false}
                value={rawSearchValue.value}
                placeholder="Hledáte něco konkrétního?"
                onChange={event =>
                    setRawSearchValue({
                        value: event.target.value,
                        loading: event.target.value
                    })
                }
                className={`outline-0 w-full flex flex-row rounded-xl pr-4 pl-2 py-3 items-center min-h-12`}
                autoComplete={'on'}
                autoFocus={false}
            />
            <div className={`${rawSearchValue.loading ? 'visible' : 'invisible'} px-2`}>
                <Spinner color={'rgb(229, 231, 235)'} backgroundColor={'#E30A18'} />
            </div>
        </ShadowContainer>
    )
}

export default SearchBar
